import ResetPassword from "../../component/reset-password/reset-password";

export default function ResetPasswordPage() {
    return (
      <ResetPassword />
    )
}
